module.exports = __webpack_public_path__ + "media/images/kebab_potatoes-904cef35e1ae213a0a8e342128a5eab0.png";